const keywordsData = '姓氏文化，中文家谱，中文家谱在线服务，中文家谱智能编辑软件，中文家谱数字出版服务，中文家谱智能阅读器，微信家族群共享空间，祖源大数据知识图谱，智慧寻根平台'
export default {
  keywordsData
}
